import authSlice from './authSlice';
import dashboardFilterSlice from './dashboardFilterSlice';
import mdCoverageSlice from './mdCoverageSlice';
import mdConcentrationSlice from './mdConcentrationSlice';
import mdReachSlice from './mdReachSlice';
import stratClassSlice from './stratClassSlice';

const resetSlice = (set) => ({
  reset: () => {
    authSlice(set).resetAuth();
    dashboardFilterSlice(set).resetDashboardFilter();
    mdCoverageSlice(set).resetMdCoverageData();
    mdConcentrationSlice(set).resetMdConcentrationData();
    mdReachSlice(set).resetMdReachData();
    stratClassSlice(set).resetStratClassData();
  },
});

export default resetSlice;
